import { render, staticRenderFns } from "./IndustryForm.vue?vue&type=template&id=3c3969d0&scoped=true"
import script from "./IndustryForm.vue?vue&type=script&lang=js"
export * from "./IndustryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3969d0",
  null
  
)

export default component.exports